import { useQuery } from '@tanstack/react-query';
import { useApi, ApiError } from '../lib/api.js';

export interface Merchant {
  merchant_id: string;
  name: string;
  business_type: 'ecommerce_platform' | 'ecommerce_direct' | 'service_business' | 'saas_support' | 'hybrid';
  features: string[];
  primary_language_id: string;
  supported_languages: string[];
  language_mode: 'auto_detect' | 'strict_primary';
  brand_voice: string;
  upsell_level: 'off' | 'low' | 'medium' | 'high';
  response_speed: 'instant' | 'natural' | 'slow';
  working_hours_mode: 'always' | 'business_hours_only';
  escalation_threshold: number;
  platform_id: string | null;
  is_suspended: boolean;
}

export function useMerchant() {
  const api = useApi();
  return useQuery<Merchant | null>({
    queryKey: ['merchant', 'me'],
    queryFn: async () => {
      try {
        return await api.get<Merchant>('/merchants/me');
      } catch (e) {
        if (e instanceof ApiError && e.status === 404) return null;
        if (e instanceof ApiError && e.status === 401) return null;
        throw e;
      }
    },
  });
}
